import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { buildCreateApi, coreModule, reactHooksModule } from '@reduxjs/toolkit/query/react'

import { CEP } from 'Interface/ViaCep';

const createApi = buildCreateApi(
    coreModule(),
    reactHooksModule({ unstable__sideEffectsInRender: true })
);

export const apiViaCep = createApi({
    reducerPath: 'apiViaCep',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://viacep.com.br/ws',
    }),
    tagTypes: ['CEP'],
    endpoints: construtor => ({
        recuperarCep: construtor.query<CEP, string>({
            query: cep => `/${cep}/json`,
            providesTags: (resultado, erro, cep) => [{ type: 'CEP', cep }],
        }),
    }),
})

export const {
    useRecuperarCepQuery,
} = apiViaCep;
